import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  importTitle: {
    defaultMessage: 'Import products',
    id: '6ha+ms',
    description: 'Title displayed in the import drawer header',
  },
  uploadFile: {
    defaultMessage: 'Upload File',
    id: 'mHr/Xd',
    description: 'Title for the file upload step in the import process',
  },
  matchFields: {
    defaultMessage: 'Match Fields',
    id: 'JKtV1W',
    description: 'Title for the field mapping step in the import process',
  },
  importResult: {
    id: 'h/jSfc',
    defaultMessage: 'Import Products',
    description: 'Title for the step showing import processing status',
  },
  importResultSuccess: {
    id: 'q/BqS9',
    defaultMessage: 'Products Successfully Imported',
    description: 'Title displayed when inventory import completes successfully',
  },
});
